/* eslint-disable */
import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";

// import resources ------------------------------
import { assetImages } from "constants";

import * as url from "helper/UrlHelper";
import { getData } from "utils/Gateway";
import { makeStripePayment } from "helper/StripePaymentHelper/StripePaymentHelper";

const PayInvoice = () => {
  const { id: invoiceId } = useParams();
  
  const token = localStorage.getItem("token");
  const userInfo = JSON.parse(localStorage.getItem("userInfo"));

  const [invoiceData, setInvoiceData] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [isPaymentProcessing, setIsPaymentProcessing] = useState(false);

  // Function to get invoice details
  const getInvoiceDetails = async () => {
    try {
      setIsLoading(true);
      let requestUrl =
        url.API_BASE_URL +
        url.API_GET_INVOICE_DETAILS +
        `/${invoiceId}`;

      const response = await getData(requestUrl);

      console.log("Invoice details response:", response.data);

      if (response.data) {
        setInvoiceData(response.data);
      }
      setIsLoading(false);
    } catch (error) {
      console.log("Error fetching invoice details:", error.message);
      setIsLoading(false);
    }
  };

  // Function to handle payment
  const handleMakePayment = async () => {
    if (!invoiceData || !invoiceId) {
      alert("Invoice data not available");
      return;
    }

    setIsPaymentProcessing(true);

    try {
      const redirectUrl = url.FRONTEND_BASE_URL + "/payment/success";

      await makeStripePayment(invoiceId, token, userInfo._id, redirectUrl);
    } catch (error) {
      console.log("Payment error:", error.message);
      alert("Payment failed. Please try again.");
    } finally {
      setIsPaymentProcessing(false);
    }
  };

  // Fetch invoice details on component mount
  useEffect(() => {
    if (invoiceId && token) {
      getInvoiceDetails();
    } else {
      window.location.href = "/";
    }
  }, [invoiceId, token]);

  if (isLoading) {
    return (
      <section className="pt-70">
        <div className="container-fluid">
          <div className="py-4 px-3">
            <div className="text-center">
              <div className="spinner-border" role="status">
                <span className="visually-hidden">Loading...</span>
              </div>
              <p className="mt-3">Loading invoice details...</p>
            </div>
          </div>
        </div>
      </section>
    );
  }

  if (!invoiceData) {
    return (
      <section className="pt-70">
        <div className="container-fluid">
          <div className="py-4 px-3">
            <div className="text-center">
              <img
                src={assetImages.emptyVector}
                alt="No Invoice"
                className="mb-3"
              />
              <h4 className="fw-semibold text-black mb-2">Invoice Not Found</h4>
              <p className="text-muted mb-4">
                The invoice you're looking for doesn't exist or has been removed.
              </p>
              <button
                className="btn btn-primary"
                onClick={() => window.location.href = "/"}
              >
                Go Home
              </button>
            </div>
          </div>
        </div>
      </section>
    );
  }

  return (
    <section className="pt-70">
      <div className="container-fluid">
        <div className="py-4 px-3">
          <div className="row justify-content-center">
            <div className="col-lg-8">
              <div className="card border-0 shadow-sm rounded-10">
                <div className="card-header bg-primary text-white p-4">
                  <h3 className="mb-0 fw-semibold">Quick Payment</h3>
                  <p className="mb-0 opacity-75">Reference ID: {invoiceData.invoiceid}</p>
                </div>
                
                <div className="card-body p-4">
                  {/* Invoice Details */}
                  <div className="row mb-4">
                    <div className="col-md-6">
                        <h5 className="fw-semibold mb-3">Bill From / Requester:</h5>
                        <div className="mb-2">
                            <strong>Name:</strong> {invoiceData.user?.name || "N/A"} {invoiceData.user?.surname || ""}
                        </div>
                        <div className="mb-2">
                            <strong>Email:</strong> {invoiceData.user?.email || "N/A"}
                        </div>
                        <div className="mb-2">
                            <strong>Phone:</strong> {invoiceData.user?.phone || "N/A"}
                        </div>
                    </div>
                    
                    <div className="col-md-6">
                        <h5 className="fw-semibold mb-3">Bill To / Payer:</h5>
                        <div className="mb-2">
                            <strong>Name:</strong> {invoiceData.client?.name || userInfo?.name || "N/A"} {invoiceData.client?.surname || userInfo?.surname || ""}
                        </div>
                        <div className="mb-2">
                            <strong>Email:</strong> {invoiceData.client?.email || userInfo?.email || "N/A"}
                        </div>
                        <div className="mb-2">
                            <strong>Phone:</strong> {invoiceData.client?.phone || userInfo?.phone || "N/A"}
                        </div>
                    </div>
                  </div>

                  {/* Invoice Dates and Amount */}
                  <div className="row mb-4">
                    <div className="col-md-6">
                      <div className="mb-3">
                        <strong>Reference ID:</strong>
                        <div className="text-muted">
                          {invoiceData.invoiceid || "N/A"}
                        </div>
                      </div>
                      <div className="mb-3">
                        <strong>Created Date:</strong>
                        <div className="text-muted">
                          {invoiceData.createddate
                            ? new Date(invoiceData.createddate).toLocaleDateString("en-GB")
                            : "N/A"}
                        </div>
                      </div>
                      <div className="mb-3">
                        <strong>Due Date:</strong>
                        <div className="text-danger">
                          {invoiceData.duedate
                            ? new Date(invoiceData.duedate).toLocaleDateString("en-GB")
                            : "N/A"}
                        </div>
                      </div>
                    </div>
                    
                    <div className="col-md-6">
                      <div className="bg-light p-3 rounded-10">
                        <h5 className="fw-semibold mb-2">Amount Due</h5>
                        <h2 className="text-primary fw-bold mb-0">
                          €{invoiceData.totalpayble}
                        </h2>
                      </div>
                    </div>
                  </div>

                  {/* Payment Status */}
                  <div className="mb-4">
                    <h5 className="fw-semibold mb-2">Payment Status:</h5>
                    <span className={`badge ${invoiceData.payment ? 'bg-success' : 'bg-warning'} fs-6`}>
                      {invoiceData.paymentstatus}
                    </span>
                  </div>

                  {/* Comments */}
                  {invoiceData.comments && (
                    <div className="mb-4">
                      <h5 className="fw-semibold mb-2">Comments:</h5>
                      <p className="text-muted">{invoiceData.comments}</p>
                    </div>
                  )}

                  {/* Action Buttons */}
                  <div className="text-center">
                    {!invoiceData.payment ? (
                      <button
                        className="btn btn-primary btn-lg px-5 py-3 fw-semibold"
                        onClick={handleMakePayment}
                        disabled={isPaymentProcessing}
                      >
                        {isPaymentProcessing ? (
                          <>
                            <span className="spinner-border spinner-border-sm me-2" role="status">
                              <span className="visually-hidden">Loading...</span>
                            </span>
                            Processing Payment...
                          </>
                        ) : (
                          <>
                            <i className="material-icons me-2">payment</i>
                            Make Payment
                          </>
                        )}
                      </button>
                    ) : (
                      <div className="alert alert-success d-flex align-items-center justify-content-center">
                        <i className="material-icons me-2">check_circle</i>
                        This invoice has already been paid
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default PayInvoice;
